import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasVideo = createSelector(selectJsonQuery, jsonQuery => getTermValue('has_video')(jsonQuery));
